import { api } from "..";

export const stepUpTest = async () => {
  const res = await api.client.post("/tests/step-up");
  return res.data;
};
